import React from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import './bootstrap.css';
import MainPage from './MainPage';
import Form from './Form';
import MaterialList from './MaterialList';
import NotFound from './NotFound';

function AppContent() {
  const location = useLocation();
  const hideNavbar = location.pathname === '/';

  return (
    <>
      {!hideNavbar && (
        <nav className="navbar navbar-expand bg-light mb-3">
          <div className="container">
            <div className="navbar-nav justify-content-center w-100">
              <Link className="nav-link" to="/">Home</Link>
              <Link className="nav-link" to="/form">Formularz</Link>
              <Link className="nav-link" to="/list">Lista</Link>
            </div>
          </div>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/list" element={<MaterialList />} />
        <Route path="/form" element={<Form />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <footer className="mt-5 py-3 border-top text-center text-muted small">
        <div className="container">
          Copyright &copy; Wojciech Piaskowski
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;